module.exports = __webpack_public_path__ + "img/Descriptive Analysis.053d7ed9.png";